<template>
  <modalDialog class="modal--personalized" @close="close">
    <div slot="form" class="form">
      <p class="form__title">
        {{ textStatus }}
      </p>
      <img class="form__img" :src="imageStatus" />
    </div>
    <div slot="footer">
      <button save class="btn btn--red modal__btn button-save" @click="close">
        {{ $t("global.button.accept") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";

export default {
  components: {
    modalDialog
  },
  props: {
    status: {
      required: true,
      type: Boolean
    }
  },
  name: "DialogServicePurchase",
  data: () => ({}),
  computed: {
    imageStatus() {
      try {
        return require("./assets/" +
          (this.status ? "check" : "wrong") +
          ".svg");
      } catch (error) {
        return error;
      }
    },
    textStatus() {
      return this.status
        ? this.$t("xpo.servicePurchased.ok")
        : this.$t("xpo.servicePurchased.fail");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style src="./css/common.css"></style>

<style scoped>
.form__title {
  font-size: 1rem;
  text-align: center;
}

.form__img {
  width: 4rem;
  margin: 0 auto;
  padding: 1.5rem 0;
}
</style>
